var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineCardSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h13.24c.41 0 .75.34.75.75s-.34.75-.75.75H2zM6 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.29a.749.749 0 1 1 0 1.5H6zM11 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98 21.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.58c3.14 0 3.69-.54 3.69-3.64V6.89c0-.41.34-.75.75-.75s.75.34.75.75v9.21c0 3.95-1.21 5.15-5.19 5.15H7.98zM3.43 20.84c-1.81-.72-2.18-2.41-2.18-4.73V7.89c0-3.94 1.21-5.14 5.19-5.14h11.11c1.14 0 1.98.09 2.64.29.4.12.62.53.51.93-.12.4-.54.62-.93.51-.52-.15-1.22-.22-2.22-.22H6.44c-3.14 0-3.69.54-3.69 3.64v8.21c0 2.39.43 3.02 1.24 3.34a.745.745 0 0 1-.28 1.44c-.09 0-.19-.02-.28-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCardSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-card-slash.a8af2694fb349d9b287d9d0cadefa136.svg";
export { ForwardRef as ReactComponent };